import { Children, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import { isString } from '../../helpers/validations';
import useBasePath from '../../hooks/useBasePath';
import tabsContext from './tabsContext';

const TabBody: React.FC = ({ children }) => {
    const { tabIndex, setTabIndex, disabled, swipeableRef } = useContext(tabsContext);

    const history = useHistory();

    const basePath = useBasePath();

    const handleIndexChange = (index: number) => {
        setTabIndex(index);

        const child: any = Children.toArray(children)[index];

        const { to } = child.props;

        if (isString(to)) {
            history.push(to);
            return;
        }

        //   in case `to` is neither a string or an array ( unlikely, but still)
        if (Array.isArray(to)) {
            history.push(child.props.to[0]);
            return;
        }
    };

    useEffect(() => {
        Children.toArray(children).find((child: any, index: number) => {
            const { to } = child.props;

            if (
                (isString(to) && basePath === to) ||
                (Array.isArray(to) && to.includes(basePath))
            ) {
                setTabIndex(index);
            }
            return null;
        });
    }, [children, basePath, setTabIndex]);

    return (
        <SwipeableViews
            index={tabIndex}
            onChangeIndex={handleIndexChange}
            className='swipeable-root'
            enableMouseEvents
            disabled={disabled}
            animateHeight={true}
            ref={swipeableRef}
        >
            {children}
        </SwipeableViews>
    );
};

export default TabBody;
